import { api } from '@/global/services/api'

const state = {
  showItem: {},
  viewConfig: {}
}

const getters = {
  showItem: state => state.showItem,
  viewConfig: state => state.viewConfig
}

const actions = {
  async fetch ({ commit, state }, id) {
    try {
      if (!id) {
        id = 0
      }
      const { config, data } = await api('fleet').get(`vehicles/${id}/details`)

      if (data.item && data.item.id) {
        commit('SET_SHOW_ITEM', data)
        commit('SET_VIEW_CONFIG', config)
      }

      return true
    }
    catch (e) {
      console.dir(e)
      return false
    }
  },

  setShowItem ({ commit }, data) {
    commit('SET_SHOW_ITEM', data)
  }
}

const mutations = {
  SET_SHOW_ITEM: (state, payload) => (state.showItem = payload),
  SET_VIEW_CONFIG: (state, payload) => (state.viewConfig = payload)
}

export default {
  state,
  getters,
  actions,
  mutations
}
